import React, { FC } from 'react'
import styles from 'styles/components/list.module.scss'
import { OrderBreadOptionList } from 'components/List'
import { PickupableTimeType } from 'types/bread'

type Props = {
  pickupableTimes: PickupableTimeType[]
}

const OrderBreadTimeList: FC<Props> = (props) => {
  const { pickupableTimes } = props
  return (
    <>
      {pickupableTimes.map((pickupableTime) => {
        let quantityByTime = ''
        const isNoOption = pickupableTime.choices.every((choice) => choice.choice === '')
        if (isNoOption) {
          quantityByTime = pickupableTime.choices
            .reduce((_prev, choice) => {
              return _prev + choice.quantity
            }, 0)
            .toLocaleString()
        }
        return (
          <React.Fragment key={pickupableTime.pickupable_time}>
            <div className={styles.order__accordion}>
              <span className={styles.order__accordion__cell__header}>{pickupableTime.pickupable_time}受渡解禁分</span>
              <span className={styles.order__accordion__cell}>{quantityByTime}</span>
            </div>
            {!isNoOption && <OrderBreadOptionList choices={pickupableTime.choices} />}
          </React.Fragment>
        )
      })}
    </>
  )
}

export default OrderBreadTimeList
